import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import HanziCardsTab from './HanziCardsTab';
import HanziComponentsTab from './HanziComponentsTab';
import HanziWizardTab from './HanziWizardTab';

/**
 * Hanzi: repository of Chinese characters and their components for the writing activity.
 * Universal graphic layer only (strokes, pieces, GF 0014-2009 identity); nothing of the
 * course lives here.
 */
const Hanzi: React.FC = () => {
  return (
    <ModuleContainer>
      <ItemTabs tabNames={['Characters', 'Components', 'Wizard']}>
        <HanziCardsTab />
        <HanziComponentsTab />
        <HanziWizardTab />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default Hanzi;
